import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  unit,
  heat_treatment,
  surface_treatment,
  target_date,
  _remarksControls,
  leadTime,
  _startDateControls,
  _finishDateControls,
  created_at,
  updated_at,
} from '@/table/Job/SubJob/base';
import { qc_progress_amount } from './subJob-qc';

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    // size: {
    //   name: 'ขนาดชิ้นส่วน',
    //   width: '10rem',
    // },
    amount: {
      ...amount,
      name: 'จำนวน ทั้งหมด',
    },
    qc_progress_amount,
    unit,
    heat_treatment,
    surface_treatment,
    _startDateControls,
    _finishDateControls,
    target_date,
    _remarksControls,
    leadTime,
    created_at,
    updated_at,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    // 'withdrawn_amount',
    // 'purchased_amount',
    'unit',
    'heat_treatment',
    'surface_treatment',
    'target_date',
    'qc_status',
    'created_at',
    'updated_at',
  ],
};
